import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import ChartProps from './ChartProps'
import KendoChartSeriesItem from '../KendoChartSeriesItem'


export default {
    props: ChartProps,
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    mounted() {
        this._resolveChildren()
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoChart()
        },
        _resolveChildren() {
            this.resolveChildren('series', KendoChartSeriesItem.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/KendoChartMixinBase.js